/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled } from "@mui/material/styles";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Select,
  FormHelperText,
  Button,
  DialogActions,
} from "@mui/material";
import { StyledFormFieldText } from "../styles";

export const CLOSE_ICON_COLOR = "#707070";
export const REQUIRED_FIELD_ASTERISK_COLOR = "#ff0000";

export {
  StyledTextField,
  StyledAddButton,
  StyledCancelButton,
} from "../styles";

export const SubtitleText = styled(Typography)({
  fontSize: "14px",
  color: "#6b7280",
  marginTop: "2px",
});

export const StyledImageRequirementsTitle = styled(Box)({
  fontSize: "13px",
  fontWeight: 700,
  color: "#111827",
});

export const LogoSection = styled(Box)({
  marginTop: "5px",
  padding: "18px",
  border: "1px solid #e5e7eb",
  borderRadius: "16px",
  background: "linear-gradient(180deg, #ffffff 0%, #fafafa 100%)",
});

export const LogoSectionHeader = styled(Typography)({
  fontSize: "18px",
  fontWeight: 700,
  lineHeight: "26px",
  color: "#111827",
});

export const LogoSectionSubheader = styled(Typography)({
  fontSize: "13px",
  color: "#6b7280",
  marginTop: "6px",
});

export const SharedRequirementsCard = styled(Box)({
  marginTop: "14px",
  padding: "14px 16px",
  borderRadius: "12px",
  border: "1px solid #e5e7eb",
  backgroundColor: "#fff",
});

export const RequirementList = styled("ul")({
  margin: "10px 0 0 18px",
  padding: 0,
});

export const RequirementItem = styled("li")({
  color: "#4b5563",
  fontSize: "12px",
  marginBottom: "4px",
});

export const LogoGrid = styled(Box)({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
  gap: "16px",
  marginTop: "18px",
});

export const LogoCard = styled(Box)({
  padding: "14px",
  border: "1px solid #e5e7eb",
  borderRadius: "14px",
  backgroundColor: "#fff",
});

export const LogoPreviewFrame = styled(Box)({
  width: "100%",
  minHeight: "188px",
  padding: "18px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "12px",
  border: "1px solid #e5e7eb",
  boxSizing: "border-box",
});

export const LogoPreviewImage = styled("img")({
  width: "auto",
  height: "auto",
  maxWidth: "100%",
  maxHeight: "150px",
  objectFit: "contain",
});

export const LogoActions = styled(Box)({
  display: "flex",
  gap: "8px",
  marginTop: "12px",
  flexWrap: "wrap",
});

export const StyledDialogActions = styled(DialogActions)({
  px: 3,
  py: 2,
  borderTop: "1px solid #e5e7eb",
  justifyContent: "space-between",
});

export const CustomStyledFormFieldText = styled(StyledFormFieldText)({
  marginBottom: "3px",
  fontSize: "14px !important",
});

export const SubGroupDialog = styled(Dialog)({
  "& .MuiBackdrop-root": {
    backgroundColor: "rgba(15, 23, 42, 0.45)",
  },
  "& .MuiDialog-paper": {
    width: "min(960px, calc(100vw - 32px))",
    maxWidth: "960px",
    height: "calc(100vh - 48px)",
    maxHeight: "calc(100vh - 48px)",
    margin: "24px",
    borderRadius: "12px",
    overflow: "hidden",
    backgroundImage: "none",
  },
});

export const SubGroupDialogHeader = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "16px",
  padding: "16px 20px",
  borderBottom: "1px solid #e5e7eb",
});

export const SubGroupDialogTitle = styled(Typography)({
  fontSize: "22px",
  fontWeight: 700,
  lineHeight: 1.2,
  color: "rgba(81, 81, 82, 1)",
});

export const SubGroupDialogContent = styled(DialogContent)({
  padding: 0,
  overflowY: "auto",
  height: "100%",
});

export const FormContent = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  padding: "10px 20px 32px",
});

export const FieldStack = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

export const TopFieldsGrid = styled(Box)({
  display: "grid",
  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
  gap: "16px",
  alignItems: "start",
  "@media (max-width: 720px)": {
    gridTemplateColumns: "1fr",
  },
});

export const RequirementsCard = styled(Box)({
  padding: "16px",
  borderRadius: "12px",
  border: "1px solid #e5e7eb",
  backgroundColor: "#f8fafc",
  marginBottom: "8px",
});

export const RequirementsList = styled("ul")({
  margin: "10px 0 0 18px",
  padding: 0,
});

export const UploadSection = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "3px",
});

export const PreviewFrame = styled(Box)({
  width: "100%",
  minHeight: "220px",
  padding: "18px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "12px",
  border: "1px solid #e5e7eb",
  backgroundColor: "#f8fafc",
  boxSizing: "border-box",
  marginBottom: "8px",
});

export const PreviewImage = styled("img")({
  width: "100%",
  height: "100%",
  maxHeight: "204px",
  objectFit: "contain",
});

export const UploadButton = styled(Button)({
  textTransform: "none",
  fontWeight: 600,
  borderRadius: "10px",
  width: "fit-content",
});

export const StyledSelect = styled(Select)({
  width: "100%",
  borderRadius: "8px",
  "& .MuiInputBase-root": {
    minHeight: "40px",
  },
  "& .MuiSelect-select": {
    paddingTop: "8.5px",
    paddingBottom: "8.5px",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#D8D9DB",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#395bbd",
    borderWidth: "2px",
  },
});

export const HelperError = styled(FormHelperText)({
  marginLeft: 0,
  color: "#d32f2f",
});
